"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseToggle = BaseToggle;

var _buffer = require("buffer");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _colors = require("./styles/colors");

var _react = _interopRequireWildcard(require("react"));

var _reactSwitch = _interopRequireDefault(require("react-switch"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["onToggle"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var checkIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 12\"><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M11.662 2.032L6 8.167c-.393.423-.926.69-1.5.75h-.84a2.378 2.378 0 01-1.5-.75L.337 6.24\"/></svg>";

/**
 * Toggle sizes.
 */
var toggleSizes = {
  height: 24,
  width: 40
};
/**
 * Get check icon.
 */

function getCheckIcon(props) {
  var disabled = props.disabled;
  var iconColor = disabled ? (0, _styles.color)('gray400') : (0, _styles.color)('blue500');

  var buf = _buffer.Buffer.from(checkIcon.replace('currentColor', iconColor(props)));

  return buf.toString('base64');
}
/**
 * `StyledSwitch` styled component.
 */


var StyledSwitch = (0, _styledComponents["default"])(_reactSwitch["default"]).withConfig({
  displayName: "toggle__StyledSwitch",
  componentId: "sc-1sr9rf5-0"
})(["&:focus-visible{border:2px solid ", ";border-radius:22px !important;}.react-switch-bg{&:hover{", "}", "}.react-switch-handle{display:grid !important;place-content:center;}.react-switch-handle::before{background-image:url(data:image/svg+xml;base64,", ");content:'';display:block;height:12px;opacity:0;transition:opacity ", ";width:12px;}", ""], (0, _styles.color)('blue400'), (0, _styledTools.ifProp)('checked', (0, _styledComponents.css)(["background:", " !important;"], (0, _styles.color)('blue600')), (0, _styledComponents.css)(["background:", " !important;"], (0, _styles.color)('gray600'))), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["background:", " !important;"], (0, _styles.color)('gray400'))), getCheckIcon, (0, _styledTools.theme)('animations.fastTransition'), (0, _styledTools.ifProp)('checked', (0, _styledComponents.css)([".react-switch-handle::before{opacity:1;}"])));
/**
 * Export `BaseToggle` component.
 */

function BaseToggle(props) {
  var onToggle = props.onToggle,
      rest = _objectWithoutProperties(props, _excluded);

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  return /*#__PURE__*/_react["default"].createElement(StyledSwitch, _extends({}, rest, {
    activeBoxShadow: (0, _styledTools.theme)('boxShadow.toggle')({
      theme: themeContext
    }),
    checkedIcon: false,
    handleDiameter: toggleSizes.height - 2,
    height: toggleSizes.height,
    offColor: (0, _colors.toHex)((0, _styles.color)('gray500')({
      theme: themeContext
    })),
    offHandleColor: (0, _colors.toHex)((0, _styles.color)('white')({
      theme: themeContext
    })),
    onChange: onToggle,
    onColor: (0, _colors.toHex)((0, _styles.color)('primary')({
      theme: themeContext
    })),
    onHandleColor: (0, _colors.toHex)((0, _styles.color)('white')({
      theme: themeContext
    })),
    uncheckedIcon: false,
    width: toggleSizes.width
  }));
}